"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var creator_ui_1 = require("@chameleoncreator/creator-ui");
var render_1 = require("./utils/render");
var edit_1 = require("./edit");
var useModule_1 = require("./hooks/useModule");
var useSidebar_1 = require("./hooks/useSidebar");
var frame_1 = require("./components/frame");
// import { GlobalStyles } from "./globalStyles";
exports.Editor = function (_a) {
    var data = _a.data, root = _a.root;
    var _b = useModule_1.useModule(data, root), mod = _b[0], Set = _b[1], Remove = _b[2];
    var blocks = mod.blocks;
    var renderer = render_1.Renderer(root, blocks, [render_1.editorPlugin]);
    var children = react_1.useMemo(function () { return renderer.renderRoot(); }, [blocks]);
    var ctx = useSidebar_1.useSidebar();
    return (react_1.default.createElement(useSidebar_1.EditContext.Provider, { value: ctx },
        react_1.default.createElement(creator_ui_1.Flexbox, { p: 20, height: "100vh", width: "100%" },
            react_1.default.createElement(creator_ui_1.Box, { as: "aside", flex: ["0 0 0", "0 0 0", "0 0 400px"], mr: [0, 0, 30] },
                react_1.default.createElement(edit_1.Sidebar, null)),
            react_1.default.createElement(creator_ui_1.Box, { as: "main", height: "100%", flex: "1" },
                react_1.default.createElement(creator_ui_1.BrowserWindow, null,
                    react_1.default.createElement(frame_1.Frame, null, children))))));
};
